import * as Yup from "yup";

export const messages = [
  {
    message: "At least 1 symbol and 1 uppercase character.",
    fn: (password) => {
      if (!password) return "DEFAULT";
      const hasUpperCase = /[A-Z]/.test(password);
      const hasSymbol = /[@$!%*?&#^()_\-+=]/.test(password);
      return (hasUpperCase && hasSymbol) ? "CORRECT" : "ERROR";
    },
    key: "UPPER_CASE",
  },
  {
    message: "Passwords must be 8 – 19 characters long.",
    fn: (password) => {
      if (!password) return "DEFAULT";
      return (password.length >= 8 && password.length <= 19) ? "CORRECT" : "ERROR";
    },
    key: "PASSWORD_LENGTH",
  },
  {
    message: "Cannot match username or email address.",
    fn: (password, email, fname, lname) => {
      if (!password) return "DEFAULT";
      if (!email && !fname && !lname) return "CORRECT"
      const lowerPassword = password.toLowerCase();
      const matchesEmail = email && lowerPassword === email.toLowerCase();
      const matchesFirstname = fname && lowerPassword === fname.toLowerCase();
      const matchesLastname = lname && lowerPassword === lname.toLowerCase();
      const matchesFullName = fname && lname && lowerPassword === (fname + lname).toLowerCase();
      return (matchesEmail || matchesFirstname || matchesLastname || matchesFullName) ? "ERROR" : "CORRECT";
    },
    key: "NAME_MATCH",
  },
];

export const getPasswordSchema = (email, fname, lname, emailKey, fnameKey, lnameKey, isEditMode) => {
  console.log("Generating password schema with:", { email, fname, lname, emailKey, fnameKey, lnameKey, isEditMode });
  let schema = Yup.string();
  if(!isEditMode) {
    schema = schema.required("Password is required.");
  }
  if(isEditMode) {
    schema = schema.nullable();
    schema = schema.transform((val) => val || '')
  }
  messages.forEach((msg) => {
    schema = schema.test(
      msg.key,
      msg.message,
      function (value) {
        if(!value && isEditMode) return true; // Don't show errors on empty password in edit mode
        const emailP = email || (emailKey ? this.parent[emailKey] : null);
        const fnameP = fname || (fnameKey ? this.parent[fnameKey] : null);
        const lnameP = lname || (lnameKey ? this.parent[lnameKey] : null);
        return msg.fn(value || "", emailP, fnameP, lnameP) == "CORRECT"
      }
    );
  });
  return schema;
};
